import React from "react";
import { WorkshopAgendasUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const AgendasDropdown = ({
  resources,
  agenda,
  agendas,
  onAgendaChange,
  onRequestStart,
  onRequestEnd,
  filter,
  containerClass,
  helperText = null,
  defaultValue = null,
  inputName = "agenda",
  id = "agendas-dropdown",
  disabled = false,
  required = false,
}) => {

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["Agenda"]}
      value={agenda}
      placeholder={defaultValue ?? resources["DefaultDropdownValue"]}
      values={agendas}
      handleChange={onAgendaChange}
      inputName={inputName}
      addMarginBottom={false}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={WorkshopAgendasUrl()}
      map={(a) => ({ key: a.id, name: a.description })}
      filter={filter}
      sort={(a, b) => (a.description.toLowerCase().localeCompare(b.description.toLowerCase()))}
    />
  );
};

export default AgendasDropdown;
